import { RefreshCw } from "lucide-react";

function ResetButton({handleReset}: {handleReset: () => void}) {

  return (
      <>
          <button 
              onClick={handleReset}
              className="flex flex-col items-center justify-center gap-2 text-center bg-transparent w-full h-full text-h6 font-semibold text-white active:bg-ocean-700 outline-offset-[-4px] !outline-white"
              aria-controls="outages_map"
              id="map_reset_button"
          >
              <div aria-hidden="true">
                <RefreshCw size={28} />
                {/* <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="22" height="23.083" data-name="UI - Icons Reset"><path fill="#fff" d="M11.376 22.722a11.525 11.525 0 0 1-1.231-.066A11.378 11.378 0 1 1 21.874 7.109a1.728 1.728 0 1 1-3.2 1.295 7.892 7.892 0 1 0-2.354 9.109 7.574 7.574 0 0 0 .572-.529 1.728 1.728 0 1 1 2.438 2.449 10.843 10.843 0 0 1-.839.769 11.278 11.278 0 0 1-7.115 2.52Z" data-name="Path 3446"/><g data-name="Group 3358"><path fill="#fff" d="M19.831 23.083a1.729 1.729 0 0 1-1.728-1.69l-.071-3.195-3.195.071h-.039a1.728 1.728 0 0 1-.038-3.456l4.923-.109a1.725 1.725 0 0 1 1.766 1.69l.109 4.922a1.728 1.728 0 0 1-1.69 1.766Z" data-name="Path 3447"/></g></svg> */}
              </div>
              
              <span>Reset map</span>
          </button>
      </>
  );
}

export default ResetButton
